.popoverContent {
  display: flex;
  background-color: var(--cxy-color-surface-success-default-subtle-hover);
  flex-direction: column;
  border-radius: var(--cxy-border-radius-s);
  box-shadow: var(--cxy-box-shadow-a);
  z-index: var(--cxy-z-index-popover);
  overflow: hidden;
  margin-top: var(--cxy-spacing-3);
  color: var(--cxy-color-text-default-body);
}

.trigger[aria-expanded='true'] {
  color: var(--cxy-color-brand);
}
